document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".fade-up");
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("in-view");
                observer.unobserve(entry.target); // Animate only once
            }
        });
    }, {
        threshold: 0.15
    });
    elements.forEach(element => {
        observer.observe(element);
    });
});